import { useContext } from "react";
import "./HambargarClick.css";
import { ThemeContext } from "./context/themeContext";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  FileText,
  Network,
  ShoppingBag,
  ShoppingCart,
  Users,
  UserPlus,
  Layers,
  Clock,
} from "lucide-react";

export default function HambargarClick({ toggle, onClose }) {
  const { activeTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();

  const navTo = (path, tokenized = false, state = null) => {
    navigate(path, { state });
    onClose();
  };

  const isActive = (path) => location.pathname.startsWith(path);
  const isExact = (path) => location.pathname === path;

  return (
    <>
      {toggle && (
        <div className={`hambargar-flyout ${activeTheme === "dark" ? "dark-mode" : ""}`}>
          {/* Logo — commented out; flyout header already conveys brand context */}
          {/* <div className="flyout-logo-wrap">
            <img src="/image/logo.png" alt="MarsMate" className="Hambargar-logo" />
            <img src="/image/logo-dark.png" alt="MarsMate" className="Hambargar-logo-dark" />
          </div> */}

          {/* Navigation */}
          <nav className="flyout-nav">
            {/* Main */}
            <button
              className={`flyout-nav-item ${isExact("/dashboard") ? "active" : ""}`}
              onClick={() => navTo("/dashboard")}
            >
              <span className="flyout-nav-icon"><Home size={15} /></span>
              <span className="flyout-nav-label">Home</span>
            </button>

            <button className="flyout-nav-item flyout-nav-disabled" disabled>
              <span className="flyout-nav-icon flyout-soon-icon-wrap">
                <Users size={15} />
                <span className="flyout-soon-dot"><Clock size={9} /></span>
              </span>
              <span className="flyout-nav-label">Investor Matching</span>
            </button>

            <button className="flyout-nav-item flyout-nav-disabled" disabled>
              <span className="flyout-nav-icon flyout-soon-icon-wrap">
                <UserPlus size={15} />
                <span className="flyout-soon-dot"><Clock size={9} /></span>
              </span>
              <span className="flyout-nav-label">Registration</span>
            </button>

            {/* History section */}
            <div className="flyout-section-divider" />
            <p className="flyout-section-label">History</p>

            <button
              className={`flyout-nav-item ${
                ((isActive("/reports-hub") || isActive("/reports")) &&
                  location.state?.tab !== "mm" &&
                  location.state?.tab !== "mind-mapping") ||
                isActive("/report") ||
                isActive("/report-b") ||
                isActive("/scorecard")
                  ? "active"
                  : ""
              }`}
              onClick={() => navTo("/reports-hub", true, { tab: "idea" })}
            >
              <span className="flyout-nav-icon"><FileText size={15} /></span>
              <span className="flyout-nav-label">Idea Validation Reports</span>
            </button>

            <button
              className={`flyout-nav-item ${
                (isActive("/reports-hub") &&
                  (location.state?.tab === "mm" ||
                    location.state?.tab === "mind-mapping")) ||
                isActive("/mind-mapping")
                  ? "active"
                  : ""
              }`}
              onClick={() => navTo("/reports-hub", true, { tab: "mind-mapping" })}
            >
              <span className="flyout-nav-icon"><Network size={15} /></span>
              <span className="flyout-nav-label">Mind Mapping Reports</span>
            </button>

            {/* Plug & Play section */}
            <div className="flyout-section-divider" />
            <p className="flyout-section-label">Plug &amp; Play</p>

            <button
              className={`flyout-nav-item ${isActive("/product") ? "active" : ""}`}
              onClick={() => navTo("/product", true)}
            >
              <span className="flyout-nav-icon"><ShoppingBag size={15} /></span>
              <span className="flyout-nav-label">Products</span>
            </button>

            <button
              className={`flyout-nav-item ${isActive("/product") ? "active" : ""}`}
              onClick={() => navTo("/product", true)}
            >
              <span className="flyout-nav-icon"><Layers size={15} /></span>
              <span className="flyout-nav-label">Popular Categories</span>
            </button>

            {/* Cart */}
            <div className="flyout-section-divider flyout-divider-cart" />
            <button
              className={`flyout-nav-item flyout-cart-item ${isActive("/cart") ? "active" : ""}`}
              onClick={() => navTo("/cart", true)}
            >
              <span className="flyout-nav-icon"><ShoppingCart size={15} /></span>
              <span className="flyout-nav-label">Cart</span>
            </button>
          </nav>
        </div>
      )}
    </>
  );
}
